import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { RecutChip } from 'fym-shared/src/music24/musicVideoDoc';
import { TypedMemo } from '../../common/types';
import { recutChipMessages } from '../messages/timelineMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface RecutChipsProps {
  chips: readonly RecutChip[];
  picked: readonly RecutChip[];
  onChange: (picked: RecutChip[]) => void;
}

/** The chips of a recut (design c6, f2: "Faster cuts", "Calmer", …). Each one turns on and off. */
const RecutChipsComponent: React.FC<RecutChipsProps> = ({ chips, picked, onChange }) => {
  const intl = useIntl();
  return (
    <div className={styles.chips}>
      {chips.map((chip) => {
        const isOn = picked.includes(chip);
        return (
          <button
            key={chip}
            type="button"
            className={clsx(styles.chip, isOn && styles.chipOn)}
            aria-pressed={isOn}
            onClick={() => onChange(isOn ? picked.filter((item) => item !== chip) : [...picked, chip])}
          >
            {intl.formatMessage(recutChipMessages[chip])}
          </button>
        );
      })}
    </div>
  );
};

export const RecutChips = TypedMemo(RecutChipsComponent);
